'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthenticationState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _enumify = require('enumify');

var _contextUtils = require('./contextUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_FORBIDDEN_COMPONENT = function DEFAULT_FORBIDDEN_COMPONENT() {
    return null;
};
var DEFAULT_AUTH_CANCELLED_COMPONENT = function DEFAULT_AUTH_CANCELLED_COMPONENT() {
    return _react2.default.createElement(
        'div',
        null,
        'You are not logged in'
    );
};

/**
 * props:
 * * forbiddenComponent - component to show, when user authenticates right now
 * * authCancelledComponent - component to show, if user reject the authentication
 * * pageComponent - component to show, only if user will authenticate successfully
 * * routerProps - react-router v4 props
 */

var AuthenticationState = exports.AuthenticationState = function (_Enum) {
    _inherits(AuthenticationState, _Enum);

    function AuthenticationState() {
        _classCallCheck(this, AuthenticationState);

        return _possibleConstructorReturn(this, (AuthenticationState.__proto__ || Object.getPrototypeOf(AuthenticationState)).apply(this, arguments));
    }

    return AuthenticationState;
}(_enumify.Enum);

AuthenticationState.initEnum(['IN_PROGRESS', 'SUCCEED', 'CANCELLED']);

var IN_PROGRESS = AuthenticationState.IN_PROGRESS,
    SUCCEED = AuthenticationState.SUCCEED,
    CANCELLED = AuthenticationState.CANCELLED;


var enhance = (0, _recompose.compose)(_contextUtils.passApplication);

var AuthenticatedPage = function (_React$Component) {
    _inherits(AuthenticatedPage, _React$Component);

    function AuthenticatedPage(props) {
        _classCallCheck(this, AuthenticatedPage);

        var _this2 = _possibleConstructorReturn(this, (AuthenticatedPage.__proto__ || Object.getPrototypeOf(AuthenticatedPage)).call(this, props));

        _this2.state = { authenticationState: IN_PROGRESS };
        return _this2;
    }

    _createClass(AuthenticatedPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            var _props = this.props,
                authorization = _props.application.authorization,
                onClose = _props.onClose;

            if (!authorization.isAuthenticated()) {
                authorization.login().then(function () {
                    if (!authorization.isAuthenticated()) {
                        throw new Error('cancelled by user');
                    }
                    _this3.setState({ authenticationState: SUCCEED });
                    return null;
                }).catch(function () {
                    // authentication cancelled by user
                    _this3.setState({ authenticationState: CANCELLED });
                    typeof onClose === 'function' && onClose();
                });
            } else {
                this.setState({ authenticationState: SUCCEED });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                forbiddenComponent = _props2.forbiddenComponent,
                authCancelledComponent = _props2.authCancelledComponent,
                pageComponent = _props2.pageComponent,
                routerProps = _props2.routerProps;
            var authenticationState = this.state.authenticationState;

            forbiddenComponent = forbiddenComponent ? forbiddenComponent : DEFAULT_FORBIDDEN_COMPONENT;
            authCancelledComponent = authCancelledComponent ? authCancelledComponent : DEFAULT_AUTH_CANCELLED_COMPONENT;

            var result = void 0;
            switch (authenticationState) {
                case IN_PROGRESS:
                    result = _react2.default.createElement(forbiddenComponent);
                    break;

                case SUCCEED:
                    result = _react2.default.createElement(pageComponent, routerProps);
                    break;

                case CANCELLED:
                    result = _react2.default.createElement(authCancelledComponent);
                    break;

                default:
                    throw new Error('invalid authentication state');
            }

            return result;
        }
    }]);

    return AuthenticatedPage;
}(_react2.default.Component);

exports.default = enhance(AuthenticatedPage);


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/AuthenticatedPage.js
// module id = 1298
// module chunks = 118